// super-script-modal.component.ts
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-super-script-modal',
  templateUrl: './super-script-modal.component.html',
})
export class SuperScriptModalComponent implements OnInit {
  @Output() action = new EventEmitter();
  @Input() form: FormGroup;
  @Input() mode: 'add' | 'edit'; 

  constructor(public modalRef: MDBModalRef) {}

  ngOnInit(): void {
    // You can initialize your form here if needed
  }

  save(): void {
    if (this.form.valid) {
      this.action.emit({data: this.form.value, mode: this.mode});
      this.modalRef.hide();
    }
  }
}
